import script from "./WelcomeFreePlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeFreePlanModal.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeFreePlanModal.vue?vue&type=style&index=0&id=290c12e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290c12e8"]])

export default __exports__